import logo from './logo.svg';
import './App.css';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import Login from './Login/Login';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap';
import Home from './pages/Home';
import MainLayout from './pages/MainLayout';
import Strategies from './pages/Strategies';
import CreateStrategies from './pages/CreateStrategies';
import Contact from './pages/Contact';
import MarketPlace from './pages/MarketPlace';
import Help from './pages/Help';
import Profile from './pages/Profile';
import StrategiesDC from './components/StrategiesDC';
import Subscribe from './pages/Subscribe';
import Flowchart from './pages/Flowchart';
import Flow from './Flowchart/Flowchart';
import PrivateRoute from './PrivateRoute';
import Strategy from './components/strategy/Strategy';
import { MyProvider } from './context/MyContext';
import AboutStrategies from './pages/AboutStrategies';
import Result from './components/Results';
import Analytics from './pages/Analytics';


const routerConfig = [
  {
    path: "/",
    element: <Login />
  },
  {
    path: "/",
    element: <MainLayout />,
    children: [
      {
        path: "dashboard",
        element: <PrivateRoute element={<Home />} />
      },
      {
        path: "strategies",
        element: <PrivateRoute element={<Strategies />} />
      },
      {
        path: "AboutStrategies",
        element: <PrivateRoute element={<AboutStrategies />} />
      },
      {
        path: "strategies-details",
        element: <PrivateRoute element={<StrategiesDC />} />
      },
      {
        path: "create-strategies",
        element: <PrivateRoute element={<Strategy />} />
      },
      {
        path: "contact",
        element: <PrivateRoute element={<Contact />} />
      },
      // Marketplace route commented out - not accessible
      // {
      //   path: "marketplace",
      //   element: <PrivateRoute element={<MarketPlace />} />
      // },
      {
        path: "aboutStrategy",
        element: <PrivateRoute element={<AboutStrategies />} />
      },
      {
        path: "help",
        element: <PrivateRoute element={<Help />} />
      },
      {
        path: "subscribe",
        element: <PrivateRoute element={<Subscribe />} />
      },
      {
        path: "profile",
        element: <PrivateRoute element={<Profile />} />
      },
      {
        path: "result",
        element: <PrivateRoute element={<Result />} />
      },
      {
        path: "analytics",
        element: <PrivateRoute element={<Analytics />} />
      }
    ]
  }
];

const router = createBrowserRouter(routerConfig, {
  future: {
    v7_startTransition: true,
  },
});

function App() {
  return (
    <MyProvider>
      <RouterProvider router={router} />
    </MyProvider>
  );
}

export default App;
